import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 接口信息
   */
  static getWalletInfo() {
    return Request({
      url: `wallet/queryAccounts`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取最新一项明细
   */
  static getTransactionList(pageNum) {
    return Request({
      url: `wallet/queryAccountTradeInfos/2/${pageNum}/10`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取各种优惠券数量
   */
  static getCouponCount(params) {
    return Request({
      url: `coupon/count`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/CisternWallet/CisternWalletServ.js